//pkgs.ts

import { apiProvider } from "./utilities/provider";
import { JsonDocument } from "./utilities/json";
import { Pkg } from "../../models/pkg";

export const pkgsApi = {
  add: (pkg: Pkg): Promise<Pkg> =>
    apiProvider
      .post("pkgs", {
        data: pkg,
      })
      .then((d: JsonDocument<Pkg>) => d.data),
  update: (pkg: Pkg): Promise<Pkg> =>
    apiProvider.put("pkgs", pkg.id, {
      data: pkg,
    }),
  getSingle: (id: number): Promise<Pkg> =>
    apiProvider.getSingle("pkgs", id).then((d: JsonDocument<Pkg>) => d.data),
  getAll: (): Promise<Pkg[]> =>
    apiProvider.getAll("pkgs").then((d: JsonDocument<Pkg[]>) => d.data),

  trash: (id: number): Promise<any> => apiProvider.remove("pkgs", id),
};
